import { initializeApp } from "firebase/app";
import { getMessaging, getToken } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyCi9sylO9mrpxA3IuepslDyuvNvvXvB_9g",
  authDomain: "uniform-376bd.firebaseapp.com",
  projectId: "uniform-376bd",
  storageBucket: "uniform-376bd.firebasestorage.app",
  messagingSenderId: "72226057888",
  appId: "1:72226057888:web:7e97bd06874f6765c8a3c5"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export const generateFCMToken = async () => {
  try {

    const permission = await Notification.requestPermission();

    if (permission !== "granted") {
      console.log("Notification permission denied");
      return null;
    }

    const registration = await navigator.serviceWorker.ready;

    const token = await getToken(messaging, {
      vapidKey: "BIAMb55Xb0i7vTI91VMuysutisMuv-TnhkST-rBxd8mfpkyQM8HyLzbM7sORqsu0Q-SUIxKw5vkKwiJBhnyVThw",
      serviceWorkerRegistration: registration
    });

    console.log("FCM TOKEN:", token);

    return token;

  } catch (error) {
    console.log("FCM ERROR:", error);
  }
};
